/**
 * UserPresentListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  ModalLayout,
  Text,
} from 'components';
import {
  Button,
  DatePicker,
  Radio,
  Table,
  Spin,
  Tag,
  Flex,
  Descriptions as AntDescriptions,
  Input,
  Space,
  Divider,
  Empty,
  Checkbox,
} from 'antd';
import { Link } from 'react-router-dom';
import { encrypt } from 'utils/Crypto';
import { stringToMoneyFormat } from 'utils';
import {
  LoadingOutlined,
  SearchOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { downloadXlsx } from 'utils/XlsxDownloader';
import Formatter from 'utils/Formatter';
import Payment from 'constants/Payment';
import PaymentStatus from 'constants/PaymentStatusConstants';
import {
  ORDER_ROUTE,
  ORDER_STATUS,
  PURCHASE_STATUS,
} from 'constants/OrderConstants';
import { DELIVERY_STATUS } from 'constants/ProductConstants';
import DeliveryCompany from 'constants/DeliveryCompany';
import {
  ACCOUNT_STATUS,
  SIGNUP_PATH,
  USER_SETTING,
} from 'constants/UserContants';
import {
  PRESENT_TYPE,
  PRESENT_PROVIDER_TYPE,
  PRESENT_YES_OR_NO,
} from 'constants/PresentContants';

/**----------------------------------------
 * [Component] 총관리자: 회원관리 -> 선물내역
 * ----------------------------------------
 */
const PresentListPresenter = ({
  presentList,
  // permission,
  loading,
  // currentPresent,
  // setCurrentPresent,
  setPeriod,

  // onChange,
  // inputValue,
  // setInputValue,
  modalData,
  setModalData,
  // setLoading,
  INITIAL_VALUE,
  // StampSetting,
  // onSelect,
  onSelectId,
  onPresentCancel,
  onReSendPresentMessage,
  // selectedList,
  searchValue,
  onChangeSearchValue,
  dateValue,
  setDateValue,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */

  const [expansionSendUser, setExpansionSendUser] = React.useState(false);
  const [expansionTargetUser, setExpansionTargetUser] = React.useState(false);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 150,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },

    couponLayout: {
      width: '100%',
      backgroundColor: '#f4f4f4',
      borderLeft: '20px solid #ddd',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: 20,
      paddingLeft: 20,
      position: 'relative',
      top: 0,
      left: 0,
    },
    couponTitle: {
      fontSize: 18,
      fontWeight: 700,
      marginBottom: 16,
    },
    couponStatus: {
      color: 'var(--black-color)',
      fontSize: 16,
      lineHeight: 1.75,
    },
    couponDate: {
      fontSize: 14,
      fontWeight: 700,
      color: 'var(--dark-gray-color)',
    },

    labelStyle: {
      // width: 155,
      width: '21%',
      color: '#111',
      fontWeight: '500',
      background: '#f4f4f4',
    },
    contentStyle: { width: '29%' },
    defaultStyle: {
      borderTop: '2px solid #d1d1d1',
      borderRadius: 5,
      marginTop: 5,
    },
  };

  const formItem = [
    {
      label: '선물기간',
      form: [
        {
          input: (
            <Flex gap="large" size="large">
              <Radio.Group
                size="large"
                value={dateValue.value}
                onChange={(e) =>
                  setDateValue((prev) => ({
                    ...prev,
                    value: e.target.value,
                    start_date: dayjs()
                      .subtract(e.target.value, 'day')
                      .startOf('day'),
                    end_date: dayjs().endOf('day'),
                  }))
                }
              >
                <Radio.Button value={1}>1일</Radio.Button>
                <Radio.Button value={7}>7일</Radio.Button>
                <Radio.Button value={30}>30일</Radio.Button>
                <Radio.Button value={90}>90일</Radio.Button>
              </Radio.Group>
              <Flex align="center" gap={4}>
                <DatePicker
                  size="large"
                  format={'YYYY-MM-DD'}
                  placeholder=""
                  style={{ ...styles.form.date, width: 150 }}
                  value={dateValue.start_date}
                  onChange={(e) =>
                    setDateValue((prev) => ({
                      ...prev,
                      start_date: dayjs(e).startOf('day'),
                    }))
                  }
                  maxDate={dateValue.end_date}
                />
                <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
                <DatePicker
                  size="large"
                  format={'YYYY-MM-DD'}
                  placeholder=""
                  style={{ ...styles.form.date, width: 150 }}
                  value={dateValue.end_date}
                  onChange={(e) =>
                    setDateValue((prev) => ({
                      ...prev,
                      end_date: dayjs(e).endOf('day'),
                    }))
                  }
                  minDate={dateValue.start_date}
                />
              </Flex>
            </Flex>
          ),
        },
      ],
    },
  ];

  const col = [
    {
      title: '선물번호',
      dataIndex: 'present_id',
      key: 'present_id',
      width: 100,
      fixed: 'left',
      render: (present_id) => <>{present_id}</>,
      sorter: (a, b) => a.present_id - b.present_id,
    },
    {
      title: '바코드',
      dataIndex: 'barcode',
      key: 'barcode',
      width: 100,
      render: (barcode) => <>{barcode}</>,
      filterDropdown: ({
        selectedKeys,
        setSelectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={selectedKeys[0] || ''}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              onChangeSearchValue('barcode', e.target.value);
            }}
            onPressEnter={() => confirm()}
            placeholder={`바코드 검색`}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              검색
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                onChangeSearchValue('barcode', '');
              }}
              size="small"
              style={{ width: 90 }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
    },
    {
      title: '보낸사람',
      dataIndex: 'send_user',
      key: 'send_user',
      width: 200,
      // fixed: 'left',
      render: (send_user) => (
        <>
          {send_user?.user_name}({send_user?.user_phone})
        </>
      ),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={selectedKeys[0] || ''}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              onChangeSearchValue('send_user', e.target.value);
            }}
            onPressEnter={() => confirm()}
            placeholder={`이름 또는 번호 검색`}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              검색
            </Button>
            <Button
              onClick={() => {
                onChangeSearchValue('send_user', null); // 초기화 시 검색 텍스트 비우기
                clearFilters();
              }}
              size="small"
              style={{ width: 90 }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
    },
    {
      title: '받은사람',
      dataIndex: 'target_user',
      key: 'target_user',
      width: 200,
      // fixed: 'left',
      render: (target_user) => (
        <>
          {target_user?.user_name}({target_user?.user_phone})
        </>
      ),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={selectedKeys[0] || ''}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);

              onChangeSearchValue('target_user', e.target.value);
            }}
            onPressEnter={() => confirm()}
            placeholder={`이름 또는 번호 검색`}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              검색
            </Button>
            <Button
              onClick={() => {
                onChangeSearchValue('target_user', null); // 초기화 시 검색 텍스트 비우기
                clearFilters();
              }}
              size="small"
              style={{ width: 90 }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
    },
    {
      title: '선물타입',
      dataIndex: 'type',
      key: 'type',
      width: 100,
      render: (type) => (
        <>
          <Tag color={PRESENT_TYPE[type].color}>{PRESENT_TYPE[type].label}</Tag>
        </>
      ),
      filters: Object.entries(PRESENT_TYPE).map(([key, v]) => ({
        text: v.label,
        value: key,
      })),
      onFilter: (value, record) => record.type.includes(value),
    },
    {
      title: '판매자',
      dataIndex: 'shop_information_name',
      key: 'shop_information_name',
      width: 150,
      render: (shop_information_name) => <>{shop_information_name}</>,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={selectedKeys[0] || ''}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              onChangeSearchValue('shop_information_name', e.target.value);
            }}
            onPressEnter={() => confirm()}
            placeholder={`판매자 검색`}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              검색
            </Button>
            <Button
              onClick={() => {
                onChangeSearchValue('shop_information_name', null); // 초기화 시 검색 텍스트 비우기
                clearFilters();
              }}
              size="small"
              style={{ width: 90 }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
    },
    {
      title: '상품명',
      dataIndex: 'product',
      key: 'product',
      width: 200,
      fixed: 'left',
      render: (product, record) => (
        <div
          style={{
            maxWidth: 200,
            overflowX: 'auto',
            whiteSpace: 'nowrap',
          }}
        >
          {record.type === 'MENU'
            ? product?.menu_name
            : record.type == 'PRODUCT'
            ? product?.product_name
            : '금액권'}
        </div>
      ),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={selectedKeys[0] || ''}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              onChangeSearchValue('product_name', e.target.value);
            }}
            onPressEnter={() => confirm()}
            placeholder={`상품명 검색`}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              검색
            </Button>
            <Button
              onClick={() => {
                onChangeSearchValue('product_name', null); // 초기화 시 검색 텍스트 비우기
                clearFilters();
              }}
              size="small"
              style={{ width: 90 }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
    },
    {
      title: '단가',
      dataIndex: 'price',
      key: 'price',
      width: 150,
      render: (_, record) => (
        <>{stringToMoneyFormat(record?.product?.price)} 원</>
      ),
      sorter: {
        compare: (a, b) => a?.product?.price - b?.product?.price,
        multiple: 2,
      },
    },
    {
      title: '결제금액',
      dataIndex: 'payment_price',
      key: 'payment_price',
      width: 150,
      render: (payment_price) => <>{stringToMoneyFormat(payment_price)} 원</>,
      sorter: {
        compare: (a, b) => a.payment_price - b.payment_price,
        multiple: 2,
      },
    },
    {
      title: '배송비',
      dataIndex: 'delivery_price',
      key: 'delivery_price',
      width: 150,
      render: (delivery_price) => <>{stringToMoneyFormat(delivery_price)} 원</>,
      sorter: {
        compare: (a, b) => a.delivery_price - b.delivery_price,
        multiple: 2,
      },
    },
    {
      title: '구매수량/금액',
      dataIndex: 'received_present',
      key: 'received_present',
      width: 150,
      render: (received_present, record) => (
        <>
          {stringToMoneyFormat(received_present)}
          {record?.type === 'CASH_VOUCHER' ? '원' : '개'}
        </>
      ),
      sorter: {
        compare: (a, b) => a.received_present - b.received_present,
        multiple: 2,
      },
    },
    {
      title: '사용수량/금액',
      dataIndex: 'used_present',
      key: 'used_present',
      width: 150,
      render: (used_present, record) => (
        <>
          {stringToMoneyFormat(used_present)}
          {record?.type === 'CASH_VOUCHER' ? '원' : '개'}
        </>
      ),
      sorter: {
        compare: (a, b) => a.used_present - b.used_present,
        multiple: 2,
      },
    },
    {
      title: '선물상태',
      dataIndex: 'payment_state',
      key: 'payment_state',
      width: 150,
      render: (payment_state) => (
        <>{payment_state === 'COMPLETED' ? '완료' : '취소'}</>
      ),
      sorter: {
        compare: (a, b) => a.used_present - b.used_present,
        multiple: 2,
      },
    },
    {
      title: '구매일',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 200,
      render: (created_at) => (
        <>{dayjs.unix(created_at).format('YYYY-MM-DD (HH:mm:ss)')}</>
      ),
      sorter: {
        compare: (a, b) => a.created_at - b.created_at,
        multiple: 2,
      },
    },
    {
      title: '만료일',
      dataIndex: 'expired_date',
      key: 'expired_date',
      width: 200,
      render: (expired_date) => (
        <>{dayjs.unix(expired_date).format('YYYY-MM-DD (HH:mm:ss)')}</>
      ),
      sorter: {
        compare: (a, b) => a.expired_date - b.expired_date,
        multiple: 2,
      },
    },
    {
      title: '연장횟수',
      dataIndex: 'extendable_count',
      key: 'extendable_count',
      width: 100,
      render: (extendable_count) => <>{extendable_count} 번</>,
      sorter: {
        compare: (a, b) => a.extendable_count - b.extendable_count,
        multiple: 2,
      },
    },
    {
      title: '제공업체',
      dataIndex: 'provider_type',
      key: 'provider_type',
      width: 150,
      render: (provider_type) => (
        <>{provider_type === 'JM' ? '제이엠커피그룹' : '외부업체'}</>
      ),
      filters: Object.entries(PRESENT_PROVIDER_TYPE).map(([key, v]) => ({
        text: v.text,
        value: key,
      })),
      onFilter: (value, { provider_type }) => provider_type.includes(value),
    },
    {
      title: '메세지전송여부',
      dataIndex: 'is_sent',
      key: 'is_sent',
      width: 150,
      render: (is_sent, record) => (
        <Flex justify="center" align="center" gap={5}>
          <p>{is_sent === 'Y' ? '성공' : '실패'}</p>
          <p>
            <Button
              size="small"
              type="primary"
              onClick={() => onReSendPresentMessage(record)}
            >
              재전송
            </Button>
          </p>
        </Flex>
      ),
      filters: Object.entries(PRESENT_YES_OR_NO).map(([key, v]) => ({
        text: v['SENT'].text,
        value: key,
      })),
      onFilter: (value, { is_sent }) => is_sent === value,
      onCell: () => ({
        onClick: (e) => e.stopPropagation(), // 클릭 이벤트 전파 방지
      }),
    },
    {
      title: '결제정보',
      dataIndex: 'payment_info',
      key: 'payment_info',
      width: 250,
      render: (payment_info) => (
        <>
          <li>- 결제 승인번호: {payment_info?.trno}</li>
          <li>- 결제 금액: {payment_info?.amt}</li>
          <li>- 카드사: {payment_info?.msg1}</li>
          <li>
            - 결제시간:{payment_info?.trddt}-{payment_info?.trdtm}
          </li>
        </>
      ),
    },
    {
      title: '결제취소정보',
      dataIndex: 'cancel_payment_info',
      key: 'cancel_payment_info',
      width: 250,
      render: (cancel_payment_info) => {
        return cancel_payment_info ? (
          <>
            <li>- 취소 승인번호: {cancel_payment_info?.tid} </li>
            <li>- 취소 금액: {cancel_payment_info?.cancelAmount} </li>
            <li>- 카드사: {cancel_payment_info?.issuerCardName} </li>
            <li>
              - 취소시간: {cancel_payment_info?.tradeDateTime.slice(0, 8)}
              {'-'}
              {cancel_payment_info?.tradeDateTime.slice(8, 14)}
            </li>
          </>
        ) : (
          <>{'-'}</>
        );
      },
    },
    {
      title: '#',
      align: 'center',
      dataIndex: '#',
      // key: 'present_id',
      fixed: 'right',
      width: 70,
      render: (_, record) => (
        <Button
          type="primary"
          color="danger"
          size="small"
          style={{ marginBottom: 2.5 }}
          disabled={
            record?.cancel_payment_info || record?.used_present > 0
              ? true
              : false
          }
          onClick={() => {
            if (!window.confirm('해당 선물의 결제를 취소하시겠습니까?')) return;
            onSelectId(record?.present_id);
            onPresentCancel();
          }}
        >
          결제취소
        </Button>
      ),
      onCell: () => ({
        onClick: (e) => e.stopPropagation(), // 클릭 이벤트 전파 방지
      }),
    },
  ];

  const modalCol = {
    ORDER: [
      {
        title: '주문번호',
        dataIndex: 'order_id',
        key: 'order_id',
        width: 100,
        fixed: 'left',
        render: (order_id) => <>{order_id}</>,
        sorter: (a, b) => a.order_id - b.order_id,
      },
      {
        title: '매장명',
        dataIndex: 'shop_information_name',
        key: 'shop_information_name',
        width: 200,
        render: (_, record) => (
          <>{record?.shop_information?.shop_information_name}</>
        ),
      },
      {
        title: '주문경로',
        dataIndex: 'order_route',
        key: 'order_route',
        filters: Object.entries(ORDER_ROUTE).map(([key, v]) => ({
          text: v.label,
          value: key,
        })),
        onFilter: (value, record) => record.order_route.includes(value),
        width: 100,
      },
      {
        title: '결제금액',
        dataIndex: 'final_price',
        key: 'final_price',
        width: 150,
        render: (final_price) => <>{stringToMoneyFormat(final_price)}원</>,
        sorter: (a, b) => a.final_price - b.final_price,
      },
      {
        title: (
          <span style={{ lineHeight: 0.5 }}>
            할인금액
            <br />
            <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
              (선물금액 포함)
            </span>
          </span>
        ),
        dataIndex: 'final_discount',
        key: 'final_discount',
        width: 120,
        render: (final_discount) => (
          <>{stringToMoneyFormat(final_discount)}원</>
        ),
        sorter: (a, b) => a.final_discount - b.final_discount,
      },
      {
        title: '선뭀금액',
        dataIndex: 'present_price',
        key: 'present_price',
        width: 100,
        render: (_, record) => (
          <>
            {stringToMoneyFormat(
              record?.present_info?.reduce(
                (acc, present) => acc + present?.price * present.num,
                0
              )
            )}
            원
          </>
        ),
        sorter: (a, b) =>
          a?.present_info?.reduce(
            (acc, present) => acc + present?.price * present.num,
            0
          ) -
          b?.present_info?.reduce(
            (acc, present) => acc + present?.price * present.num,
            0
          ),
      },
      {
        title: '쿠폰수량',
        dataIndex: 'coupon_info',
        key: 'coupon_info',
        width: 100,
        render: (coupon_info) => <>{coupon_info?.length || 0}</>,
        sorter: (a, b) => a.coupon_info?.length - b.coupon_info?.length,
      },

      {
        title: '주문상태',
        dataIndex: 'order_status',
        key: 'order_status',
        width: 100,
        render: (order_status) => <>{ORDER_STATUS[order_status]?.title}</>,
        filters: Object.entries(ORDER_STATUS).map(([key, v]) => ({
          text: v.label,
          value: key,
        })),
        onFilter: (value, record) => record.order_status.includes(value),
      },
      {
        title: '결제상태',
        dataIndex: 'payment_state',
        key: 'payment_state',
        width: 100,
        render: (payment_state) => <>{PaymentStatus[payment_state]?.title}</>,
        filters: [
          { text: '완료', value: 'COMPLETED' },
          { text: '환불', value: 'REFUNDED' },
        ],
        onFilter: (value, record) => record.payment_state.includes(value),
      },
      {
        title: '결제수단',
        dataIndex: 'payment_method',
        key: 'payment_method',
        width: 150,
        render: (payment_method) => (
          <>{Payment.PAYMENT_METHOD[payment_method]}</>
        ),
      },
      {
        title: '주문일',
        dataIndex: 'created_at',
        key: 'created_at',
        width: 200,
        render: (created_at) =>
          dayjs.unix(created_at).format('YYYY-MM-DD (HH:mm:ss)'),
        sorter: (a, b) => a.created_at - b.created_at,
      },
      {
        title: '상세내역',
        dataIndex: 'product_information',
        key: 'product_information',
        width: 300,
        render: (product_information) => (
          <div>
            <table
              style={{
                border: 'none',
                padding: 0,
                fontSize: '0.9em',
                lineHeight: 1,
              }}
            >
              {product_information.map((item) => (
                <tr>
                  <td>
                    {/* == 메뉴명 == */}
                    <p>
                      <b>- {item.menu_name}</b>
                    </p>
                    {/* == 옵션목록 == */}
                    {item?.menu_option?.length > 0 ? (
                      <ul
                        style={{
                          padding: 3.5,
                          background: '#f7f7f7',
                          maxHeight: 58,
                          overflowY: 'scroll',
                        }}
                        className="custom-scroll"
                      >
                        {item?.menu_option?.map((menuOption, ind) => (
                          <li
                            key={`akwossll${ind}`}
                            style={{
                              fontSize: '0.9em',
                              paddingLeft: 2.5,
                              borderLeft: '1px solid #333',
                            }}
                          >
                            옵션) {menuOption.option_title}
                            {menuOption?.option?.map((op, op_ind) => (
                              <p
                                key={`w0odmm${op_ind}`}
                                style={{ fontSize: '0.95em' }}
                              >
                                - {op.option_name}{' '}
                                {menuOption.type === 'DEFAULT'
                                  ? `(필수)`
                                  : `(${op.count})`}
                              </p>
                            ))}
                          </li>
                        ))}
                      </ul>
                    ) : null}
                  </td>
                  <td style={{ textAlign: 'right' }}>{item.num}개</td>
                  <td style={{ textAlign: 'right', width: 85 }}>
                    {stringToMoneyFormat(item.price * item.num)}원
                  </td>
                </tr>
              ))}
            </table>
          </div>
        ),
      },
      {
        title: '쿠폰내역',
        dataIndex: 'coupon_info',
        key: 'coupon_info',
        width: 300,
        render: (coupon_info) => (
          <div>
            <table
              style={{
                border: 'none',
                padding: 0,
                fontSize: '0.9em',
                lineHeight: 1,
              }}
            >
              {coupon_info?.map((item) => (
                <tr>
                  <td>
                    {/* == 쿠폰명 == */}
                    <p>
                      <b>- {item?.coupon_name}</b>
                    </p>
                    <ul
                      style={{
                        padding: 3.5,
                        background: '#f7f7f7',
                        maxHeight: 58,
                        overflowY: 'scroll',
                      }}
                      className="custom-scroll"
                    >
                      <li
                        style={{
                          fontSize: '0.9em',
                          paddingLeft: 2.5,
                          borderLeft: '1px solid #333',
                        }}
                      >
                        <p style={{ fontSize: '0.95em' }}>
                          쿠폰타입 : {item?.coupon_type}
                        </p>
                        <p style={{ fontSize: '0.95em' }}>
                          할인 : {item?.discount_rate}{' '}
                          {item?.discount_type === 'W' ? '원' : '%'}
                        </p>
                      </li>
                    </ul>
                  </td>
                  <td style={{ textAlign: 'right' }}>1 개</td>
                  <td style={{ textAlign: 'right', width: 85 }}>
                    {item?.discount_price ? '-' : ''}
                    {stringToMoneyFormat(item?.discount_price)}원
                  </td>
                </tr>
              ))}
            </table>
          </div>
        ),
      },
      {
        title: '결제정보',
        dataIndex: 'payment_info',
        key: 'payment_info',
        width: 400,
        render: (payment_info, record) =>
          payment_info ? (
            record?.order_route === 'APP' ? (
              <>
                <li>- 결제 승인번호: {payment_info?.trno}</li>
                <li>- 결제 금액: {payment_info?.amt}</li>
                <li>- 카드사: {payment_info?.msg1}</li>
                <li>
                  - 결제시간:{payment_info?.trddt}-{payment_info?.trdtm}
                </li>
              </>
            ) : record?.order_route === 'KIOSK' ? (
              <>
                <li>- 결제 승인번호: {payment_info?.payment_auth_number}</li>
                <li>- 결제날짜:{payment_info?.payment_date}</li>
              </>
            ) : (
              <></>
            )
          ) : (
            <></>
          ),
      },
    ],
    SHOP_ORDER: [
      {
        title: '주문번호',
        dataIndex: 'shop_order_id',
        key: 'shop_order_id',
        width: 100,
        fixed: 'left',
        render: (shop_order_id) => <>{shop_order_id}</>,
      },
      {
        title: '매장명',
        dataIndex: 'shop_information_name',
        key: 'shop_information_name',
        width: 200,
        render: (_, record) => (
          <>{record?.shop_information?.shop_information_name}</>
        ),
      },
      {
        title: '결제금액',
        dataIndex: 'final_price',
        key: 'final_price',
        width: 100,
        render: (final_price) => <>{stringToMoneyFormat(final_price)}원</>,
      },
      {
        title: '선물금액',
        dataIndex: 'present_price',
        key: 'present_price',
        width: 150,
        render: (_, record) => (
          <>{stringToMoneyFormat(Math.abs(record?.final_discount))}원</>
        ),
      },
      {
        title: '추가 배송비',
        dataIndex: 'final_price',
        key: 'final_price',
        width: 150,
        render: (final_price) => <>{stringToMoneyFormat(final_price)}원</>,
      },
      {
        title: '결제수단',
        dataIndex: 'payment_method',
        key: 'payment_method',
        width: 150,
        render: (payment_method) => (
          <>{Payment.PAYMENT_METHOD[payment_method]}</>
        ),
      },
      {
        title: '결제상태',
        dataIndex: 'purchase_status',
        key: 'purchase_status',
        width: 100,
        render: (_, record) => (
          <>{PURCHASE_STATUS[record?.parcel_service?.purchase_status]?.title}</>
        ),
      },
      {
        title: '주문일',
        dataIndex: 'created_at',
        key: 'created_at',
        width: 200,
        render: (created_at) =>
          dayjs.unix(created_at).format('YYYY-MM-DD (HH:mm:ss)'),
      },
      {
        title: '운송장번호',
        dataIndex: 'invoice_number',
        key: 'invoice_number',
        width: 200,
        render: (_, record) => (
          <>{record?.parcel_service?.invoice_number || '-'}</>
        ),
      },
      {
        title: '택배사',
        dataIndex: 'delivery_company',
        key: 'delivery_company',
        width: 100,
        render: (_, record) => (
          <>
            {DeliveryCompany[record?.parcel_service?.delivery_company]?.label ||
              '-'}
          </>
        ),
      },
      {
        title: '배송상태',
        dataIndex: 'delivery_status',
        key: 'delivery_status',
        width: 200,
        render: (_, record) => (
          <>{DELIVERY_STATUS[record?.parcel_service?.delivery_status]?.title}</>
        ),
      },
      {
        title: '배송완료일',
        dataIndex: 'delivery_status',
        key: 'delivery_status',
        width: 200,
        render: (_, record) =>
          record?.parcel_service?.delivery_data
            ? dayjs
                .unix(record?.parcel_service?.delivery_data)
                .format('YYYY-MM-DD (HH:mm:ss)')
            : '-',
      },
      {
        title: '상세내역',
        dataIndex: 'product_information',
        key: 'product_information',
        width: 300,
        render: (product_information) => (
          <div>
            <table
              style={{
                border: 'none',
                padding: 0,
                fontSize: '0.9em',
                lineHeight: 1,
              }}
            >
              {product_information.map((item) => (
                <tr>
                  <td>
                    {/* == 메뉴명 == */}
                    <p>
                      <b>- {item?.product_name}</b>
                    </p>
                  </td>
                  <td style={{ textAlign: 'right' }}>{item.num}개</td>
                  <td style={{ textAlign: 'right', width: 85 }}>
                    {stringToMoneyFormat(item.price * item.num)}원
                  </td>
                </tr>
              ))}
            </table>
          </div>
        ),
      },
      {
        title: '배송정보',
        dataIndex: 'delivery_address',
        key: 'delivery_address',
        width: 400,
        render: (delivery_address) =>
          delivery_address ? (
            <li>
              <span>이름: {delivery_address?.recipient_name}</span>
              <br />
              <span>휴대번호: {delivery_address?.recipient_phone}</span>
              <br />
              <span>
                주소: ({delivery_address?.recipient_postcode})
                {delivery_address?.recipient_address},
                {delivery_address?.recipient_address_detail}
              </span>
              <br />
              <span>요청사항: {delivery_address?.request}</span>
            </li>
          ) : (
            <></>
          ),
      },
      {
        title: '결제정보',
        dataIndex: 'payment_info',
        key: 'payment_info',
        width: 400,
        render: (payment_info) =>
          payment_info ? (
            <>
              <li>- 결제 승인번호: {payment_info?.trno}</li>
              <li>- 결제 금액: {payment_info?.amt}</li>
              <li>- 카드사: {payment_info?.msg1}</li>
              <li>
                - 결제시간:{payment_info?.trddt}-{payment_info?.trdtm}
              </li>
            </>
          ) : (
            <></>
          ),
      },
    ],
  };

  const modalUserCol = {
    SEND_USER: [
      {
        key: '1',
        label: '회원번호',
        children: (
          <Link
            target="_blank"
            to={`/users/list?modal=${encodeURIComponent(
              encrypt(modalData?.send_user?.user_id)
            )}`}
          >
            {modalData?.send_user?.user_id}
          </Link>
        ),
      },
      {
        key: '2',
        label: '회원명',
        children: `${modalData?.send_user?.user_name ?? '-'}`,
      },
      {
        key: '3',
        label: '회원 아이디',
        children: `${modalData?.send_user?.user_account ?? '-'}`,
      },
      {
        key: '4',
        label: '계정상태',
        children: (
          <Tag
            color={ACCOUNT_STATUS[modalData?.send_user?.account_status]?.color}
          >
            {ACCOUNT_STATUS[modalData?.send_user?.account_status]?.title}
          </Tag>
        ),
      },
      {
        key: '5',
        label: '연락처',
        children: `${modalData?.send_user?.user_phone ?? '-'}`,
      },
      {
        key: '6',
        label: '이메일',
        children: `${modalData?.send_user?.user_email ?? '-'}`,
      },
      {
        key: '7',
        label: '성별',
        children: `${modalData?.send_user?.user_gender === 'M' ? '남' : '여'}`,
      },
      {
        key: '8',
        label: '생년월일',
        children: `${Formatter.unixToDate(
          modalData?.send_user?.user_birthday,
          'YYYY.MM.DD'
        )}`,
      },
      //내용 상세보기
      ...(expansionSendUser === true
        ? [
            {
              key: '9',
              label: '주소',
              children: (
                <Flex justify="space-between" align="center">
                  <Text size={14} maxLine={2}>{`(${
                    modalData?.send_user?.postcode
                  }) ${modalData?.send_user?.user_address ?? '-'}\n${
                    modalData?.send_user?.user_address_detail ?? ''
                  }`}</Text>
                </Flex>
              ),
              span: 2,
            },
            {
              key: '10',
              label: '닉네임',
              children: `${modalData?.send_user?.user_nick_name ?? '-'}`,
            },
            {
              key: '11',
              label: '멤버십 번호',
              children: `${
                Formatter.membership(modalData?.send_user?.membership_code) ??
                '-'
              }`,
            },
            {
              key: '12',
              label: '가입일',
              children: `${Formatter.unixToDate(
                modalData?.send_user?.created_at,
                'YYYY.MM.DD HH:mm:ss'
              )}`,
            },
            {
              key: '13',
              label: '최근 접속일',
              children: `${Formatter.unixToDate(
                modalData?.send_user?.access_time,
                'YYYY.MM.DD HH:mm:ss'
              )}`,
            },
            {
              key: '14',
              label: '가입경로',
              children: `${
                modalData?.send_user?.social_type
                  ? SIGNUP_PATH[modalData?.send_user?.social_type]
                  : modalData?.send_user?.user_name
                  ? SIGNUP_PATH['MEMBER']
                  : SIGNUP_PATH['NONE']
              }`,
              span: 2,
            },
            {
              key: '15',
              label: '회원설정',
              children: (
                <div>
                  {Object.entries(modalData?.send_user?.user_setting || {}) // user_setting이 없으면 빈 객체 처리
                    .map(([key, value], index) => {
                      if (!USER_SETTING[key]) return null; // 조건이 충족되지 않으면 null 반환

                      return (
                        <p
                          style={{
                            // margin: '8px 0px',
                            margin: 0,
                            padding: '5px 0',
                            textAlign: 'left',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderTop: index > 0 ? '1px solid #f1f1f1' : 'none',
                          }}
                        >
                          <p style={{ margin: 0 }}>{USER_SETTING[key]}:</p>{' '}
                          <p style={{ margin: 0 }}>
                            {value ? (
                              <Tag
                                icon={<CheckCircleOutlined />}
                                color="success"
                              >
                                동의
                              </Tag>
                            ) : (
                              <Tag
                                icon={<MinusCircleOutlined />}
                                color="default"
                              >
                                미동의
                              </Tag>
                            )}
                          </p>
                          {/* <p>{value ? '동의' : '미동의'}</p> */}
                        </p>
                      );
                    })}
                </div>
              ),
              span: 2,
            },
            {
              key: '16',
              label: '메모',
              children: <>{modalData?.send_user?.memo}</>,
              span: 2,
            },
          ]
        : []),
    ],
    TARGET_USER: [
      {
        key: '1',
        label: '회원번호',
        children: (
          <Link
            target="_blank"
            to={`/users/list?modal=${encodeURIComponent(
              encrypt(modalData?.target_user?.user_id)
            )}`}
          >
            {modalData?.target_user?.user_id}
          </Link>
        ),
      },
      {
        key: '2',
        label: '회원명',
        children: `${modalData?.target_user?.user_name}`,
      },
      //비회원 내용 상세보기
      ...(modalData?.target_user?.user_birthday
        ? [
            {
              key: '3',
              label: '회원 아이디',
              children: `${modalData?.target_user?.user_account ?? '-'}`,
            },
            {
              key: '4',
              label: '계정상태',
              children: (
                <Tag
                  color={
                    ACCOUNT_STATUS[modalData?.target_user?.account_status]
                      ?.color
                  }
                >
                  {
                    ACCOUNT_STATUS[modalData?.target_user?.account_status]
                      ?.label
                  }
                </Tag>
              ),
            },
            {
              key: '5',
              label: '연락처',
              children: `${modalData?.target_user?.user_phone ?? '-'}`,
            },
            {
              key: '6',
              label: '이메일',
              children: `${modalData?.target_user?.user_email ?? '-'}`,
            },
            {
              key: '7',
              label: '성별',
              children: `${
                modalData?.target_user?.user_gender === 'M' ? '남' : '여'
              }`,
            },
            {
              key: '8',
              label: '생년월일',
              children: `${Formatter.unixToDate(
                modalData?.target_user?.user_birthday,
                'YYYY.MM.DD'
              )}`,
            },
            //내용 상세보기
            ...(expansionTargetUser === true
              ? [
                  {
                    key: '9',
                    label: '주소',
                    children: (
                      <Flex justify="space-between" align="center">
                        <Text size={14} maxLine={2}>{`(${
                          modalData?.target_user?.postcode
                        }) ${modalData?.target_user?.user_address ?? '-'}\n${
                          modalData?.target_user?.user_address_detail ?? ''
                        }`}</Text>
                      </Flex>
                    ),
                    span: 2,
                  },

                  {
                    key: '10',
                    label: '닉네임',
                    children: `${
                      modalData?.target_user?.user_nick_name ?? '-'
                    }`,
                  },
                  {
                    key: '11',
                    label: '멤버십 번호',
                    children: `${
                      Formatter.membership(
                        modalData?.target_user?.membership_code
                      ) ?? '-'
                    }`,
                  },
                  {
                    key: '12',
                    label: '가입일',
                    children: `${Formatter.unixToDate(
                      modalData?.target_user?.created_at,
                      'YYYY.MM.DD HH:mm:ss'
                    )}`,
                  },
                  {
                    key: '13',
                    label: '최근 접속일',
                    children: `${Formatter.unixToDate(
                      modalData?.target_user?.access_time,
                      'YYYY.MM.DD HH:mm:ss'
                    )}`,
                  },
                  {
                    key: '14',
                    label: '가입경로',
                    children: `${
                      modalData?.target_user?.social_type
                        ? SIGNUP_PATH[modalData?.target_user?.social_type]
                        : modalData?.target_user?.user_name
                        ? SIGNUP_PATH['MEMBER']
                        : SIGNUP_PATH['NONE']
                    }`,
                    span: 2,
                  },
                  {
                    key: '15',
                    label: '회원설정',
                    children: (
                      <div>
                        {Object.entries(
                          modalData?.target_user?.user_setting || {}
                        ) // user_setting이 없으면 빈 객체 처리
                          .map(([key, value], index) => {
                            if (!USER_SETTING[key]) return null; // 조건이 충족되지 않으면 null 반환

                            return (
                              <p
                                style={{
                                  // margin: '8px 0px',
                                  margin: 0,
                                  padding: '5px 0',
                                  textAlign: 'left',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  borderTop:
                                    index > 0 ? '1px solid #f1f1f1' : 'none',
                                }}
                              >
                                <p style={{ margin: 0 }}>
                                  {USER_SETTING[key]}:
                                </p>{' '}
                                <p style={{ margin: 0 }}>
                                  {value ? (
                                    <Tag
                                      icon={<CheckCircleOutlined />}
                                      color="success"
                                    >
                                      동의
                                    </Tag>
                                  ) : (
                                    <Tag
                                      icon={<MinusCircleOutlined />}
                                      color="default"
                                    >
                                      미동의
                                    </Tag>
                                  )}
                                </p>
                                {/* <p>{value ? '동의' : '미동의'}</p> */}
                              </p>
                            );
                          })}
                      </div>
                    ),
                    span: 2,
                  },
                  {
                    key: '16',
                    label: '메모',
                    children: <>{modalData?.send_user?.memo}</>,
                    span: 2,
                  },
                ]
              : []),
          ]
        : [
            {
              key: '3',
              label: '연락처',
              children: `${modalData?.target_user?.user_phone ?? '-'}`,
            },
            {
              key: '4',
              label: '가입일',
              children: `${Formatter.unixToDate(
                modalData?.target_user?.created_at,
                'YYYY.MM.DD HH:mm:ss'
              )}`,
            },
          ]),
    ],
  };

  const [columnsKey, setColumnsKey] = React.useState(
    col.map((c) => c.dataIndex)
  );

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  /**
   * 포인트 조건 검색
   * --
   * @param {string} t
   */
  const filterList = React.useMemo(() => {
    let arr = presentList;

    const {
      product_name,
      barcode,
      send_user,
      target_user,
      shop_information_name,
    } = searchValue;

    if (product_name) {
      arr = arr.filter((item) => {
        if (item?.type === 'MENU') {
          return item?.product?.menu_name?.includes(product_name);
        } else {
          return item?.product?.product_name?.includes(product_name);
        }
      });
    }

    if (barcode) {
      arr = arr.filter((item) => item?.barcode?.includes(barcode));
    }

    if (send_user) {
      arr = arr.filter(
        (item) =>
          item?.send_user?.user_name?.includes(send_user) ||
          item?.send_user?.user_phone?.replace(/-/g, '').includes(send_user)
      );
    }

    if (target_user) {
      arr = arr.filter(
        (item) =>
          item?.target_user?.user_name?.includes(target_user) ||
          item?.target_user?.user_phone
            ?.replace(/-/g, '')
            ?.includes(target_user)
      );
    }

    if (shop_information_name) {
      arr = arr.filter((item) =>
        item?.shop_information_name?.includes(shop_information_name)
      );
    }

    return arr;
  }, [searchValue, presentList]);

  const visibleColumns = React.useMemo(() => {
    return col.filter((c) => columnsKey.includes(c.dataIndex));
  }, [columnsKey]);

  /* ===== FUNCTION ===== */
  const columnOptions = col.map((c) => {
    return {
      label:
        typeof c.title !== 'string'
          ? c?.title?.props.children
              .map((child) =>
                typeof child === 'string' ? child : child.props?.children || ''
              )
              .join(' ')
          : c.title,
      value: c.dataIndex,
    };
  });

  return (
    <>
      {/* === Loading - start === */}
      <Spin spinning={loading} indicator={<LoadingOutlined spin />}>
        {/* ===== 헤더&필터 - start ===== */}
        <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
          {/* === 타이틀 === */}
          <Title style={{ ...styles.title }}>선물 내역</Title>

          {/* === 필터 - start === */}
          <ExpandableContainer borderRadius={4} padding={20}>
            {formItem.map((_item, _index) => (
              <div
                key={`form_${_index}`}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '10px 0px',
                }}
              >
                <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                  <label>{_item.label}</label>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {_item.form.map((_subitem, _subkey) => (
                    <React.Fragment key={`input_${_subkey}`}>
                      {_subitem.input}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))}
          </ExpandableContainer>

          {/* 검색/초기화 버튼 */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              marginTop: 13,
            }}
          >
            <Button
              size="large"
              type="primary"
              style={{
                ...styles.button,
                background: 'var(--primary-color)',
              }}
              onClick={() => {
                setPeriod({
                  start_date: dateValue.start_date.unix(),
                  end_date: dateValue.end_date.unix(),
                });
              }}
            >
              검색
            </Button>
            <Button
              size="large"
              style={{ ...styles.button }}
              onClick={() => {
                setPeriod({
                  start_date: INITIAL_VALUE.start_date.unix(),
                  end_date: INITIAL_VALUE.end_date.unix(),
                });
                setDateValue(INITIAL_VALUE);
              }}
            >
              초기화
            </Button>
          </div>
          {/* 검색/초기화 버튼 끝 */}
          {/* === 필터 - end === */}
        </Content>
        {/* ===== 헤더&필터 - end ===== */}

        <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
          {/* === 통계 - start === */}
          {/* <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{
              marginBottom: 4,
              display: 'flex',
              gap: '2px',
            }}
          >
            {[
              // {
              //   title: '기간별 회원 총 적립 스탬프',
              //   value: summary.all_users_stamp,
              //   suffix: '개',
              // },
              // {
              //   title: '회원 총 적립 스탬프',
              //   value: summary.total_stamp,
              //   suffix: '개',
              // },
              // {
              //   title: '미사용 스탬프',
              //   value: summary.not_expired_stamp,
              //   suffix: '개',
              // },
              // {
              //   title: '사용 스탬프',
              //   value: summary.used_stamp,
              //   suffix: '개',
              // },
              // {
              //   title: '만료 예정 스탬프(7일 기준)',
              //   value: summary.expired_7ago_stamp,
              //   suffix: '개',
              // },
              // {
              //   title: '만료 스탬프',
              //   value: summary.expired_stamp,
              //   suffix: '개',
              // },
            ].map((_item, _index) => (
              <div
                key={`${_item.label}-${_index}`}
                className="boxShadow"
                style={{
                  background: '#FFFFFF',
                  borderRadius: 4,
                  width: '100%',
                  margin: '2px',
                  padding: '26px 14px',
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}
              >
                <Statistic
                  style={{ justifyContent: 'center' }}
                  title={_item.title}
                  value={_item.value}
                  suffix={_item.suffix}
                  direction={'row'}
                />
              </div>
            ))}
          </Content> */}
          {/* === 통계 - end === */}

          {/* ===== 하단컨텐츠 - start ===== */}
          {/* <Tabs
            type="card"
            size={'large'}
            defaultActiveKey="1"
            onChange={setCurrentTab}
            style={{
              padding: 0,
            }}
            items={[
              {
                label: `전체 내역`,
                key: 'all-list',
              },
              {
                label: `선물한 내역`,
                key: 'send-list',
              },
              {
                label: `선물 받은 내역`,
                key: 'receive-list',
              },
              {
                label: `주문 사용 내역`,
                key: 'order-list',
              },
              {
                label: `상품 사용 내역`,
                key: 'shop_order-list',
              },
            ]}
          /> */}
          <Col
            x={24}
            style={{
              display: 'flex',
              flexDirection: 'column',
              padding: '10px',
              marginBottom: '5px',
              backgroundColor: '#FFFFFF',
            }}
          >
            <Checkbox
              indeterminate={
                columnsKey.length > 0 &&
                columnsKey.length < columnOptions.length
              }
              checked={columnsKey.length === columnOptions.length}
              onChange={(e) => {
                if (e.target.checked) {
                  setColumnsKey(columnOptions.map((c) => c.value));
                } else {
                  setColumnsKey([]);
                }
              }}
            >
              전체 선택
            </Checkbox>
            <Checkbox.Group
              options={columnOptions}
              value={columnsKey}
              onChange={(checkedValues) => setColumnsKey(checkedValues)}
            />
          </Col>
          <Content
            maxWidth={'100%'}
            padding={20}
            backgroundColor={'#fff'}
            style={{ marginTop: -16 }}
          >
            <div>
              <Title
                size={4}
                style={{ marginBottom: 10 }}
                subButton={
                  <Button
                    onClick={() => {
                      downloadXlsx({
                        columns: col,
                        rows: filterList?.map((_item) => {
                          return {
                            ..._item,
                            send_user: `${_item.send_user?.user_name} (${_item.send_user?.user_phone})`,
                            target_user: `${_item.target_user?.user_name} (${_item.target_user?.user_phone})`,
                            product:
                              _item?.product?.menu_name ||
                              _item?.product?.product_name ||
                              '금액권',
                            price: _item?.product?.price,
                            payment_info:
                              _item?.payment_info &&
                              `결제 승인번호: ${_item?.payment_info.trno},결제 금액: ${_item?.payment_info.amt},카드사: ${_item?.payment_info?.msg1},결제시간: ${_item?.payment_info?.trddt}-${_item?.payment_info?.trdtm}`,
                            cancel_payment_info:
                              _item?.cancel_payment_info &&
                              `취소 승인번호: ${
                                _item?.cancel_payment_info.tid
                              },취소 금액: ${
                                _item?.cancel_payment_info.issuerCardName
                              },취소시간: ${_item?.cancel_payment_info?.tradeDateTime.slice(
                                0,
                                8
                              )}{'-'}${_item?.cancel_payment_info?.tradeDateTime.slice(
                                8,
                                14
                              )}`,
                          };
                        }),
                        fileName: '선물_내역',
                      });
                    }}
                  >
                    엑셀로 다운로드
                  </Button>
                }
              >
                <span>
                  검색결과 총 <a>{filterList?.length || 0}</a>건
                </span>
              </Title>
            </div>
            <Table
              scroll={{
                x: 'max-content',
              }}
              dataSource={filterList}
              style={{ minHeight: 580 }}
              // pagination={false}
              defaultPageSize={50}
              columns={visibleColumns}
              onRow={(data) => {
                return {
                  onClick: () => {
                    setModalData(data);
                  },
                };
              }}
            ></Table>
          </Content>
          {/* ===== 하단컨텐츠 - end ===== */}
        </Content>
      </Spin>
      {/* === Loading - start === */}

      <ModalLayout
        type={'drawer'}
        open={modalData}
        onCancel={() => {
          // setSelectedList([]);
          // onChange('update_date', '');
          setExpansionSendUser(false);
          setExpansionTargetUser(false);
          setModalData(null);
        }}
        title={'선물 내역 상세 정보'}
        width={'100%'}
        maxWidth={1500}
      >
        <Content maxWidth={'100%'} padding={0}>
          <Row>
            {/* === 모달 > 상세보기: start === */}
            <Col x={24}>
              <Flex vertical={true} gap={5}>
                <Title size={5} style={{ marginBottom: 5 }}>
                  보낸 회원 정보
                </Title>
                {modalData ? (
                  <AntDescriptions
                    bordered
                    column={2}
                    size="small"
                    labelStyle={styles.labelStyle}
                    contentStyle={styles.contentStyle}
                    style={styles.defaultStyle}
                    items={modalUserCol.SEND_USER}
                  />
                ) : null}
                <div>
                  {/* 내용 상세보기 */}
                  {expansionSendUser !== true ? (
                    <Button
                      type="link"
                      block
                      onClick={() => setExpansionSendUser(true)}
                    >
                      <PlusCircleOutlined /> 내용 상세보기
                    </Button>
                  ) : (
                    <Button
                      type="link"
                      block
                      onClick={() => setExpansionSendUser(false)}
                    >
                      <MinusCircleOutlined /> 내용 접기
                    </Button>
                  )}
                </div>
                <Divider style={{ margin: '13px 0' }} />
                <Title size={5} style={{ marginBottom: 5 }}>
                  받은 회원 정보
                </Title>
                {modalData ? (
                  <AntDescriptions
                    bordered
                    column={2}
                    size="small"
                    labelStyle={styles.labelStyle}
                    contentStyle={styles.contentStyle}
                    style={styles.defaultStyle}
                    items={modalUserCol.TARGET_USER}
                  />
                ) : null}
                <div>
                  {/* 내용상세보기 모달 */}
                  {modalData?.target_user?.user_birthday ? (
                    expansionTargetUser !== true ? (
                      <Button
                        type="link"
                        block
                        onClick={() => setExpansionTargetUser(true)}
                      >
                        <PlusCircleOutlined /> 내용 상세보기
                      </Button>
                    ) : (
                      <Button
                        type="link"
                        block
                        onClick={() => setExpansionTargetUser(false)}
                      >
                        <MinusCircleOutlined /> 내용 접기
                      </Button>
                    )
                  ) : null}
                </div>
                <Divider style={{ margin: '13px 0' }} />
              </Flex>
              {/* === 모달 > 상세보기 > 주문상세보기: start === */}
              <Title size={5} style={{ marginBottom: 5 }}>
                주문 상세 목록
              </Title>
              {modalData?.type === 'MENU' && modalData?.order?.length ? (
                <Row>
                  <Table
                    // rowSelection={{
                    //   columnWidth: 50, // 체크박스 열 너비 조정
                    //   size: 'large',
                    //   type: 'checkbox',
                    //   onSelect: (record, selected, selectedRows, nativeEvent) => {
                    //     onSelect(selected ? 'checked' : 'unchecked', record);
                    //   },
                    //   onSelectAll: (selected, selectedRows, changeRows) => {
                    //     onSelect(
                    //       selected ? 'all-checked' : 'all-unchecked',
                    //       selectedRows
                    //     );
                    //   },
                    //   selectedRowKeys: selected?.map((_item) => _item?.key),
                    // }}
                    // size="large"
                    // pagination={{
                    //   pageSize: 50,
                    // }}
                    // scroll={{
                    //   x: 1250,
                    //   y: 49 * 10,
                    // }}
                    scroll={{
                      x: 'max-content',
                    }}
                    defaultPageSize={50}
                    dataSource={modalData?.order}
                    columns={modalCol.ORDER}
                  />
                </Row>
              ) : modalData?.type === 'PRODUCT' &&
                modalData?.shop_order?.length ? (
                <Row>
                  <Table
                    // rowSelection={{
                    //   columnWidth: 50, // 체크박스 열 너비 조정
                    //   size: 'large',
                    //   type: 'checkbox',
                    //   onSelect: (record, selected, selectedRows, nativeEvent) => {
                    //     onSelect(selected ? 'checked' : 'unchecked', record);
                    //   },
                    //   onSelectAll: (selected, selectedRows, changeRows) => {
                    //     onSelect(
                    //       selected ? 'all-checked' : 'all-unchecked',
                    //       selectedRows
                    //     );
                    //   },
                    //   selectedRowKeys: selected?.map((_item) => _item?.key),
                    // }}
                    // size="large"
                    // pagination={{
                    //   pageSize: 50,
                    // }}
                    // scroll={{
                    //   x: 1250,
                    //   y: 49 * 10,
                    // }}
                    scroll={{
                      x: 'max-content',
                    }}
                    defaultPageSize={50}
                    dataSource={modalData?.shop_order}
                    columns={modalCol.SHOP_ORDER}
                  />
                </Row>
              ) : (
                <Empty width={'100%'}></Empty>
              )}

              {/* === 모달 > 상세보기 > 주문상세보기: end === */}
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};
PresentListPresenter.defaultProps = {
  users: [],
};
export default PresentListPresenter;
